import DescriptionListBlock from 'components/description-list-block/DescriptionListBlock';
import TableBlock from 'components/table-block/TableBlock';

import { IDescriptionListAndTables } from 'source/NFR.types';

const DescriptionListAndTables: React.FC<IDescriptionListAndTables> = ({ descriptionList, tables = [] }) => (
  <>
    <DescriptionListBlock {...descriptionList} />
    {tables?.map(table => (
      <div className="description-list-and-tables--table" key={table.title}>
        <TableBlock key={table.title} {...table} isWide />
      </div>
    ))}
  </>
);

DescriptionListAndTables.displayName = 'DescriptionListAndTables';

export default DescriptionListAndTables;
